async function sortAllSwatchesByLightness() {
    const swatchesContainers = document.querySelectorAll('.cc-swatches');

    const getLightness = (r, g, b) => {
        const [rNorm, gNorm, bNorm] = [r, g, b].map(c => c / 255);
        const max = Math.max(rNorm, gNorm, bNorm);
        const min = Math.min(rNorm, gNorm, bNorm);
        return (max + min) / 2;
    };

    const colorCache = {};  // Cache object for storing average colors

    const getAverageColor = (imageUrl) => {
        if (colorCache[imageUrl]) {
            return Promise.resolve(colorCache[imageUrl]);  // Return cached value
        }

        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'Anonymous';
            img.src = imageUrl;

            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const { data } = imageData;
                let r = 0, g = 0, b = 0;

                for (let i = 0; i < data.length; i += 4) {
                    r += data[i];
                    g += data[i + 1];
                    b += data[i + 2];
                }

                const pixelCount = data.length / 4;
                const avgColor = [Math.round(r / pixelCount), Math.round(g / pixelCount), Math.round(b / pixelCount)];
                colorCache[imageUrl] = avgColor;  // Store the result in the cache
                resolve(avgColor);
            };

            img.onerror = () => reject(`Failed to load image: ${imageUrl}`);
        });
    };

    for (const container of swatchesContainers) {
        const swatches = Array.from(container.querySelectorAll('li'));

        const lightnessPromises = swatches.map(async (swatch) => {
            const anchor = swatch.querySelector('a');
            if (!anchor) return { swatch, lightness: 1 };

            let imageUrlMatch = anchor.getAttribute('data-bgset');

            if (imageUrlMatch) {
                imageUrlMatch = imageUrlMatch.startsWith('//') ? 'https:' + imageUrlMatch : imageUrlMatch;
                imageUrlMatch = imageUrlMatch.replace('_48x48_', '_4x4_');  // Replace _48x48_ with _4x4_
            } else {
                const backgroundImage = anchor.style.backgroundImage;
                const match = backgroundImage.match(/url\(["']?(.*?)["']?\)/);
                imageUrlMatch = match ? match[1] : null;
            }

            if (!imageUrlMatch) return { swatch, lightness: 1 };

            try {
                const [r, g, b] = await getAverageColor(imageUrlMatch);
                return { swatch, lightness: getLightness(r, g, b) };
            } catch (error) {
                console.error(error);
                return { swatch, lightness: 1 };
            }
        });

        const swatchesWithLightness = await Promise.all(lightnessPromises);

        swatchesWithLightness
            .sort((a, b) => b.lightness - a.lightness)
            .forEach(({ swatch }) => container.appendChild(swatch));
    }

    setTimeout(reOrderHidden, 500);
}

// Fix hidden for additional swatches sorting
function reOrderHidden() {
    const allUl = document.querySelectorAll('ul.cc-swatches');

    allUl.forEach(ul => {
        const allLi = ul.querySelectorAll('li');
        let hiddenCount = 0;

        allLi.forEach(li => {
            if (li.classList.contains('hidden')) hiddenCount++;
            li.classList.remove('hidden');
        });

        const totalLi = allLi.length;
        for (let i = totalLi - hiddenCount; i < totalLi; i++) {
            allLi[i].classList.add('hidden');
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        sortAllSwatchesByLightness();
    }, 1000);
});
